import { SVG } from "@components/items/common/SVG";
import { ProgressBar } from "@components/items/display/ShadcnProgressBar";
import TranslatedText from "@components/items/display/TranslatedText";

import { msToHoursBalance } from "../../../../utils/helpers/timeFormtter";
// import { useRouter, useSearchParams } from 'next/navigation';
// import { useRouter as useNextRouter } from 'next/router';

interface SkillDetailsProps {
  progress: number | undefined;
  completedSummaries: number | undefined;
  totalSummaries: number | undefined;
  totalDuration: number | undefined;
  title: string | undefined;
  description: string | undefined;
  icon: string | undefined;
}

const SkillDetails = ({
  progress,
  completedSummaries,
  totalDuration,
  totalSummaries,
  title,
  description,
  icon,
}: SkillDetailsProps) => {
  // TODO: Check routing
  // const router = useRouter();
  // const searchParams = useSearchParams();
  const id = "searchParams.get('id')";

  return (
    <div
      className="flex w-[90%] items-center justify-start gap-x-4 rounded-bl-3xl bg-gradient-to-r from-[#f05ce0] to-[#5badc2] p-10"
      onClick={() =>
        // TODO: Check Router
        // router.push(`/b2b/skill/reading?id=${id}`)
        console.log(`/b2b/skill/reading?id=${id}`)
      }
    >
      <div>
        <img src={icon} alt="skill-icon" className="h-[106px] w-[106px]" />
      </div>
      <div className="flex flex-col items-start justify-center gap-y-3">
        <div className="text-[32px] font-bold text-white">{title} </div>
        <div className="text-[12px] font-medium text-white">{description}</div>
        <div className="flex items-center justify-center gap-x-3 text-white">
          <div className="grid grid-cols-12 items-center justify-center gap-x-2 p-2">
            <div className="col-span-10">
              <ProgressBar
                value={progress || 0}
                prgresserBg="bg-b2b-primary"
                height="h-[5px]"
                bgStyle="bg-[#ffff]/30"
                borderStyle="border-5 border-black"
              />
            </div>
            <div className="col-span-2 flex justify-center text-[16px] font-normal">
              {`${progress} %`}
            </div>
          </div>
          <SVG src="/assets/b2b/icons/dot.svg" />
          <div className="flex items-center gap-x-1">
            <div className="flex items-center ltr:hidden">
              <p>{totalSummaries}</p>/ <p>{completedSummaries}</p>
            </div>
            <div className="flex items-center rtl:hidden">
              <p>{completedSummaries}</p>/ <p>{totalSummaries}</p>
            </div>
            <TranslatedText text={`skill-details.card.${"summary"}`} />
          </div>
          <SVG src="/assets/b2b/icons/dot.svg" />
          <div className="flex items-center gap-x-[2px]">
            <SVG src="/assets/b2b/icons/timer.svg" height={20} width={20} />
            <div>{msToHoursBalance(totalDuration || 0)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillDetails;
